// Price bar & price line (shader)

export default class Price {

    constructor(comp) {
        this.comp = comp
    }

    // Defines an inline shader (has access to both
    // target & overlay's contexts)
    init_shader(plot) {

        let layout = this.comp.$props.layout
        let config = this.comp.$props.config
        let comp = this.comp
        let last_bar = () => this.last_bar(plot)


        this.comp.$emit('new-shader', {
            target: 'sidebar', draw: ctx => {

                let bar = last_bar()
                if (!bar) return

                let w = ctx.canvas.width
                let h = config.PANHEIGHT
                let lbl = bar.entryPoint.toFixed(layout.prec)
                ctx.fillStyle = bar.entryColor

                let x = - 0.5
                let y = bar.entry - h * 0.5 - 0.5
                let a = 7
                ctx.fillRect(x - 0.5, y, w + 1, h)
                ctx.fillStyle = comp.$props.colors.textHL
                ctx.textAlign = 'left'
                ctx.fillText(lbl, a, y + 15)

                lbl = bar.entryTarget.toFixed(layout.prec)
                ctx.fillStyle = bar.targetColor

                x = - 0.5
                y = bar.target - h * 0.5 - 0.5
                a = 7
                ctx.fillRect(x - 0.5, y, w + 1, h)
                ctx.fillStyle = comp.$props.colors.textHL
                ctx.textAlign = 'left'
                ctx.fillText(lbl, a, y + 15)

                lbl = bar.entryStoploss.toFixed(layout.prec)
                ctx.fillStyle = bar.stoplossColor

                x = - 0.5
                y = bar.stoploss - h * 0.5 - 0.5
                a = 7
                ctx.fillRect(x - 0.5, y, w + 1, h)
                ctx.fillStyle = comp.$props.colors.textHL
                ctx.textAlign = 'left'
                ctx.fillText(lbl, a, y + 15)


                lbl = bar.pendingTarget.toFixed(layout.prec)
                ctx.fillStyle = bar.pendingTargetColor

                x = - 0.5
                y = bar.pending - h * 0.5 - 0.5
                a = 7
                ctx.fillRect(x - 0.5, y, w + 1, h)
                ctx.fillStyle = comp.$props.colors.textHL
                ctx.textAlign = 'left'
                ctx.fillText(lbl, a, y + 15)

            }
        })
        this.shader = true
    }

    // Regular draw call for overaly
    draw(ctx, plot) {
        if (!this.comp.$props.meta.last) return
        if (!this.shader) this.init_shader(plot)

        let layout = this.comp.$props.layout
        let last = (plot && plot.length) ? plot[plot.length - 1] : null
        if (!last || !last.entryDirection) return

        let dir = last.entryDirection === "BUY"
        let color = dir ? this.green() : this.red()
        let x = layout.full_candles[layout.full_candles.length - 1].x
        let y = layout.$2screen(last.flashEntry) + (dir ? 1 : 0)

        ctx.strokeStyle = color
        ctx.setLineDash([1, 1])
        ctx.beginPath()
        ctx.moveTo(x, y)
        ctx.lineTo(layout.width, y)
        ctx.stroke()
        ctx.setLineDash([])

        color = this.green()
        y = layout.$2screen(last.flashTarget) + (dir ? 1 : 0)

        ctx.strokeStyle = color
        ctx.setLineDash([1, 1])
        ctx.beginPath()
        ctx.moveTo(x, y)
        ctx.lineTo(layout.width, y)
        ctx.stroke()
        ctx.setLineDash([])

        color = this.red()
        y = layout.$2screen(last.flashStoploss) + (dir ? 1 : 0)

        ctx.strokeStyle = color
        ctx.setLineDash([1, 1])
        ctx.beginPath()
        ctx.moveTo(x, y)
        ctx.lineTo(layout.width, y)
        ctx.stroke()
        ctx.setLineDash([])


        color = this.black()
        y = layout.$2screen(last.pendingTarget) + (dir ? 1 : 0)

        ctx.strokeStyle = color
        ctx.setLineDash([1, 1])
        ctx.beginPath()
        ctx.moveTo(x, y)
        ctx.lineTo(layout.width, y)
        ctx.stroke()
        ctx.setLineDash([])
    }

    last_bar(plot) {

        if (!this.comp.$props.layout.full_candles.length) return undefined
        let layout = this.comp.$props.layout
        let last = plot[plot.length - 1]
        let x = layout.$2screen(layout.full_candles[layout.full_candles.length - 1].x)
        let entry = layout.$2screen(last.flashEntry)
        let target = layout.$2screen(last.flashTarget)
        let stoploss = layout.$2screen(last.flashStoploss)
        let pending = layout.$2screen(last.pendingTarget)
        return {
            x: x,
            entry: entry,
            target: target,
            stoploss: stoploss,
            pending: pending,
            entryPoint: last.flashEntry,
            entryStoploss: last.flashStoploss,
            entryTarget: last.flashTarget,
            pendingTarget: last.pendingTarget,
            entryColor: this.green(),
            stoplossColor: this.red(),
            targetColor: this.green(),
            pendingTargetColor: this.black()
        }
    }

    last_price() {
        return this.comp.$props.meta.last ?
            this.comp.$props.meta.last[4] : undefined
    }

    green() {
        return this.comp.upBarColor
    }

    red() {
        return this.comp.downBarColor
    }

    black() {
        return this.comp.pendingTargetColor
    }

}
